import { useEffect, useMemo, useState } from './core.js';
import { isFilled } from './isFilled.js';
import { applyCache } from './AsyncCache.js';
const isFallbackKey = (args) => Boolean(args && Array.isArray(args) && args.length === 1 && typeof args[0] === 'string');
export function useAsyncData(key, fetcher, { fallback, cache } = {}) {
    const args = useMemo(() => keyToArgs(key), [key]);
    const [data, setData] = useState(undefined);
    const [error, setError] = useState(undefined);
    useEffect(() => {
        const isEmptyKey = !args.some(isFilled);
        if (isEmptyKey) {
            return;
        }
        let canceled = false;
        const setResult = (newData, err) => {
            if (!canceled) {
                setData(newData);
                setError(err);
            }
        };
        (async () => {
            try {
                setResult(await applyCache(fetcher, cache)(args));
            }
            catch (err) {
                setResult(undefined, err);
            }
        })();
        return () => {
            canceled = true;
        };
    }, [fetcher, cache, args]);
    const fallbackData = fallback && isFallbackKey(args) && fallback[args[0]];
    return {
        data: !data && fallbackData ? fallbackData : data,
        error,
        mutate: () => Promise.resolve(undefined) // TODO Clean up cache
    };
}
function keyToArgs(key) {
    if (Array.isArray(key)) {
        return key;
    }
    else if (key instanceof Function) {
        return keyToArgs(key());
    }
    else {
        return [key];
    }
}
